import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import reportWebVitals from 'helpers/reportWebVitals';
import { isDevMode } from 'helpers/storageHelpers';
import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import { WagmiProvider } from 'wagmi';
import { chainsAndWallets } from 'web3/chainsAndWallets';
import './index.css';
import { App } from './pages';
import './toastify.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

!isDevMode() && ReactGA.initialize('G-B7LJNP7VD2');

const queryClient = new QueryClient();
root.render(
  <React.StrictMode>
    <WagmiProvider config={chainsAndWallets}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);

const sendAnalytics = () => {
  !isDevMode &&
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname,
    });
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(sendAnalytics);
